(() => {
  const initInstagramLightboxes = () => {
    if (document.documentElement.dataset.trashTalkLightboxesReady === 'true') return;
    document.documentElement.dataset.trashTalkLightboxesReady = 'true';

    const prepareLightboxVideos = () => {
      document.querySelectorAll('.instafeed-lightbox video').forEach((video) => {
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';

        if (!video.poster && video.id) {
          const inlineVideo = document.getElementById(`inline-${video.id}`);
          const poster = inlineVideo?.dataset.poster || inlineVideo?.poster;
          if (poster) video.poster = poster;
        }

        const lightbox = video.closest('.instafeed-lightbox');
        if (lightbox && getComputedStyle(lightbox).display !== 'none') {
          video.muted = false;
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        }
      });
    };

    document.addEventListener('click', (event) => {
      if (event.target.closest('#insta-feed .instafeed-new-layout-item')) {
        setTimeout(prepareLightboxVideos, 0);
      }
    }, true);

    new MutationObserver(prepareLightboxVideos).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });

    prepareLightboxVideos();
  };

  const initTrashTalk = (scope = document) => {
    scope.querySelectorAll('[data-section-id]').forEach((root) => {
      if (root.dataset.trashTalkReady === 'true') return;
      root.dataset.trashTalkReady = 'true';

      const drawer = root.querySelector('[data-drawer]');
      const panels = root.querySelectorAll('[data-panel]');
      const triggers = root.querySelectorAll('[data-trigger]');
      const cursor = root.querySelector('[data-custom-cursor]');
      const instagramFeed = root.querySelector('#insta-feed');
      let active = null;

      const reelOverrides = {
        '18084542420344951-insta-feed': {
          url: 'https://www.instagram.com/trashtalkhc/reel/DceDUIrJ-kS/'
        },
        '18127498426670772-insta-feed': {
          poster: root.dataset.reelLondonPoster,
          url: 'https://www.instagram.com/trashtalkhc/reel/DcWx6ikJWXF/'
        },
        '18115817524871402-insta-feed': {
          poster: root.dataset.reelManchesterPoster,
          url: 'https://www.instagram.com/trashtalkhc/reel/DaSBPjFiwu2/'
        },
        '17945955555027708-insta-feed': {
          url: 'https://www.instagram.com/trashtalkhc/reel/DaLThgkCAFH/'
        }
      };

      if (cursor && window.matchMedia('(pointer: fine)').matches) {
        window.addEventListener('pointermove', (event) => {
          cursor.style.transform = `translate3d(${event.clientX - 9}px, ${event.clientY - 9}px, 0)`;
          cursor.classList.add('is-visible');
        });
        document.documentElement.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
      }

      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => {
          const next = trigger.dataset.trigger;
          active = active === next ? null : next;
          panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== active; });
          triggers.forEach((item) => item.setAttribute('aria-expanded', String(item.dataset.trigger === active)));
          drawer.classList.toggle('is-open', Boolean(active));
        });
      });

      if (instagramFeed) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && video.offsetParent !== null) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.15 });

        const prepareVideos = () => {
          instagramFeed.querySelectorAll('video').forEach((video) => {
            if (video.dataset.trashTalkVideoReady === 'true') return;
            video.dataset.trashTalkVideoReady = 'true';
            const poster = video.dataset.poster;
            if (poster && !video.poster) video.poster = poster;
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.autoplay = true;
            video.preload = 'metadata';
            videoObserver.observe(video);
          });
        };

        const prepareReelTiles = () => {
          instagramFeed.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
            const openId = item.querySelector('[data-instafeed-open-id]')?.dataset.instafeedOpenId;
            const reel = reelOverrides[openId];
            if (!reel || item.dataset.trashTalkReelReady === 'true') return;

            item.dataset.trashTalkReelReady = 'true';
            item.dataset.trashTalkReel = 'true';
            const image = item.querySelector('img');
            if (image && reel.poster) {
              image.src = reel.poster;
              image.dataset.instafeedSrc = reel.poster;
            }

            const openReel = (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();
              window.open(reel.url, '_blank', 'noopener,noreferrer');
            };

            item.addEventListener('click', openReel, true);
            item.addEventListener('keydown', (event) => {
              if (event.key === 'Enter' || event.key === ' ') openReel(event);
            }, true);
          });
        };

        const prepareInstagram = () => {
          prepareVideos();
          prepareReelTiles();
        };

        prepareInstagram();
        new MutationObserver(prepareInstagram).observe(instagramFeed, { childList: true, subtree: true });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initTrashTalk();
      initInstagramLightboxes();
      
    });
  } else {
    initTrashTalk();
    initInstagramLightboxes();
    
  }

  document.addEventListener('shopify:section:load', (event) => initTrashTalk(event.target));
})();
